export default {
    "loginDeviceLimitExceeded": "Đăng nhập thiết bị quá hạn",
    "ladiPageOrderCount": "LadiPage Order Alert",
    "shopWalletTransactionPaymentAccountNotMatch": "Cảnh báo tài khoản rút tiền không khớp",
    "paymenTransactionPaymentReceiveAccountNotApproved": "Cảnh báo tài khoản nhận tiền không được duyệt (Đối tác trả tiền theo mã giao dịch)",
    "paymentVndTransactionPaymentReceiveAccountNotApproved": "Cảnh báo tài khoản nhận tiền không được duyệt (Đối tác trả tiền theo thời điểm thực nhận)",
    "shopWalletTransactionNotSync": "Cảnh báo shop chưa đồng bộ giao dịch rút tiền",
    "paymentAccountNeedApproved": "Cảnh báo tài khoản cần duyệt",
    "paymentReceiveAccountNeedApproved": "Cảnh báo tài khoản nhận tiền cần duyệt",
    "airwalletPayoutReceiveAccountNotFound": "Cảnh báo không tìm thấy tài khoản nhận tiền AirWallet (Payout)",
    "airwalletPayoutPartnerNotFound": "Cảnh báo không tìm thấy đối tác thanh toán AirWallet (Payout)",
    "airwalletDepositPaymentAccountNotFound": "Cảnh báo không tìm thấy tài khoản thanh toán AirWallet (Deposit)",
    "airwalletUnmatchedDeposit": "Cảnh báo giao dịch nạp tiền AirWallet không khớp đơn hàng",
    "airwalletOtherPartnerNotFound": "Cảnh báo không tìm thấy đối tác thanh toán AirWallet",
}
